import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

export function WhatIs({
  // Props para media
  videoSrc = null,
  logoSrc = null, // Logo grande central
  imageSrc = null, // Fallback legacy
  imageAlt = "REVI logo",
}) {
  const { t } = useLandingLang();
  const centerLogo = logoSrc || imageSrc;

  return (
    <div className="w-full bg-white">
      {/* --- MÓDULO DE VÍDEO --- */}
      <div className="relative w-full overflow-visible bg-white">
        {/* Contenedor Video: Altura fija 250px según plantilla */}
        <div className="relative w-full h-[250px]">
          {videoSrc ? (
            <video
              autoPlay
              loop
              muted
              playsInline
              key={videoSrc}
              className="w-full h-full object-cover grayscale-[10%]"
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          ) : (
            <div
              className="w-full h-full bg-slate-100"
              aria-label="Vídeo fallback"
            />
          )}

          {/* Gradiente blanco superpuesto (de abajo a arriba) */}
          <div className="absolute inset-0 bg-gradient-to-t from-white via-white/40 to-transparent pointer-events-none"></div>

          {/* Logo Central Flotante */}
          {centerLogo && (
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 z-40">
              <img
                src={centerLogo}
                alt={imageAlt}
                // Tamaños y sombra exacta de la plantilla
                className="w-full max-w-[190px] lg:max-w-[240px] h-auto object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.12)]"
                loading="eager"
              />
            </div>
          )}
        </div>

        {/* --- SECCIÓN TEXTO --- */}
        {/* pt-28 para dejar espacio al logo que sobresale del video */}
        <section
          id="que-es"
          className="pt-28 pb-24 px-6 bg-white border-b border-slate-200 text-center"
          aria-label="Qué es REVI"
        >
          <div className="max-w-4xl mx-auto">
            {/* Fuentes y colores exactos de plantilla */}
            <p className="text-lg lg:text-xl text-slate-600 leading-relaxed font-medium max-w-3xl mx-auto">
              {t("whatIsText")}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
